var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPoliceCar = function SvgIconPoliceCar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.75 1.625a1 1 0 1 0 0 2h4.5a1 1 0 1 0 0-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.572 5.589a1.76 1.76 0 0 1 .84-.214h11.175a1.76 1.76 0 0 1 1.478.804l.001.002 2.855 4.444h.954a1 1 0 1 1 0 2h-.5v6.5a1.75 1.75 0 0 1-1.75 1.75h-2.25a1.75 1.75 0 0 1-1.75-1.75v-2h-9.25v2a1.75 1.75 0 0 1-1.75 1.75h-2.25a1.75 1.75 0 0 1-1.75-1.75v-6.5h-.5a1 1 0 1 1 0-2h.954l2.856-4.446c.16-.247.379-.45.637-.59M3.625 17.125v1.75h1.75v-1.75zm16.75-2v-2.5H3.625v2.5zm-1.75 2h1.75v1.75h-1.75zm-1.169-9.75 2.088 3.25H4.456l2.088-3.25z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconPoliceCar;